import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import UsersPage from "./pages/UsersPage";
import DevicesPage from "./pages/DevicesPage";
import CouponsPage from "./pages/CouponsPage";
import CreditsPage from "./pages/CreditsPage";
import MailsPage from "./pages/MailsPage";
import SettingsPage from "./pages/SettingsPage";
import LoginEventsPage from "./pages/LoginEventsPage";

import { isAuthenticated, clearAuth } from "./utils/auth";
import { clearAdminPermissionCache, loadCurrentUserPermissions } from "./utils/permissions";
import { signOut } from "./api/auth";

function App() {
  // localStorage의 토큰 존재 여부를 기준으로 초기 인증 상태 판정 (새로고침 대비)
  const [isLoggedIn, setIsLoggedIn] = useState(() => isAuthenticated());
  const [, setPermissionVersion] = useState(0);

  const refreshCurrentUserPermissions = async () => {
    try {
      await loadCurrentUserPermissions();
    } catch (err) {
      console.warn('Failed to load admin permissions:', err);
    } finally {
      setPermissionVersion((prev) => prev + 1);
    }
  };

  // LoginPage에서 saveAuth() 후 호출되는 콜백.
  // 실제 토큰 저장은 LoginPage가 이미 처리했으므로 여기서는 리렌더만 트리거.
  const handleLogin = async () => {
    await refreshCurrentUserPermissions();
    setIsLoggedIn(true);
  };

  useEffect(() => {
    if (isLoggedIn) {
      refreshCurrentUserPermissions();
    }
  }, [isLoggedIn]);

  // 로그아웃: 백엔드에 알림 + localStorage 정리 + 상태 초기화.
  const handleLogout = async () => {
    await signOut();
    clearAuth();
    clearAdminPermissionCache();
    setIsLoggedIn(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              <Navigate to="/users" replace />
            ) : (
              <LoginPage onLogin={handleLogin} />
            )
          }
        />

        <Route
          element={
            <ProtectedRoute>
              <Layout onLogout={handleLogout} />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/credits" element={<CreditsPage />} />
          <Route path="/mails" element={<MailsPage />} />
          <Route path="/login-events" element={<LoginEventsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
